
import { Route, Routes, useLocation } from 'react-router-dom';
import { Register, Login } from '../components';
import { useAuth } from '../lib';
import { useEffect } from 'react';
import { AuthLayout } from '../components/AuthLayout';

export const AuthRoutes = ({ isEnabled } : { isEnabled: boolean }) => {
  const location = useLocation();
  const state = location.state as {
    backgroundLocation?: Location;
  };

  const { updateAuthorizing } = useAuth();
  useEffect(() => {
    updateAuthorizing(!!state?.backgroundLocation && isEnabled);
  }, [state?.backgroundLocation, isEnabled])
  
  // [!state?.backgroundLocation] prevents the auth routes from being rendered if someone visits the url directly. They are only opened on top of another route when the state.backgroundLocation is set
  // [!isEnabled] prevents auth routes from being enabled when app and/or voting are closed.
  if (!state?.backgroundLocation || !isEnabled) return null;

  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />}>
        <Route
          path="login"
          element={<Login />}
        />

        <Route
          path="register"
          element={<Register />}
        />
      </Route>
    </Routes>
  );
};